module.exports = __webpack_public_path__ + "img/logo.ffe43e55.svg";